export default "__VITE_PUBLIC_ASSET__8ce05514__"